// https://github.com/wojtekmaj/react-date-picker
import React from 'react';
import { Form } from 'semantic-ui-react';
import DatePicker from 'react-date-picker/dist/entry.nostyle';
import moment from 'moment';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { DATE_FORMAT_FOR_UI } from 'Common/Constants';

export class CalendarPicker extends React.Component {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    value: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    error: PropTypes.string,
    useMoment: PropTypes.bool,
    dateFormat: PropTypes.string,
    minDate: PropTypes.string,
    maxDate: PropTypes.string,
    fluid: PropTypes.bool,
  };

  static defaultProps = {
    useMoment: false,
    dateFormat: DATE_FORMAT_FOR_UI,
  };

  handleChange = change => {
    const { dateFormat, onChange, useMoment } = this.props;

    let date = moment(change);
    onChange(
      !date.isValid() ? null : useMoment ? date : date.format(dateFormat)
    );
  };

  formatProps = () => {
    const { minDate, maxDate } = this.props;

    let props = {};
    const minDateMoment = moment(minDate);
    if (minDate && minDateMoment.isValid()) {
      props['minDate'] = minDateMoment.toDate();
    }

    const maxDateMoment = moment(maxDate);
    if (maxDate && maxDateMoment.isValid()) {
      props['maxDate'] = maxDateMoment.toDate();
    }

    return props;
  };

  render() {
    const {
      required,
      error,
      value,
      minDate,
      maxDate,
      label,
      fluid,
      className,
      onChange,
      ...rest
    } = this.props;
    return (
      <Form.Field error={error ? true : false} required={required}>
        {label && <label>{label}</label>}
        <DatePicker
          value={value ? moment(value).toDate() : null}
          {...this.formatProps()}
          onChange={this.handleChange}
          minDetail={'decade'}
          className={classNames(
            className,
            fluid ? 'react-date-picker--fluid' : ''
          )}
          {...rest}
        />
        <div style={{ height: '10px' }}>
          {error ? (
            <span className={'input--message-error'}>{error}</span>
          ) : null}
        </div>
      </Form.Field>
    );
  }
}

export function MonthPicker(props) {
  return <CalendarPicker maxDetail={'year'} {...props} />;
}

export function ReduxFormCalendarPicker(props) {
  const { input, ...rest } = props;

  // Ignore the onBlur from redux-form since it will replace the date with an empty string
  return <CalendarPicker {...input} {...rest} onBlur={() => {}} />;
}



// WEBPACK FOOTER //
// ./src/common/Components/DatePicker/DatePicker.js